import { PUBLIC_BRAND_RED_OLIVE, PUBLIC_BRAND_STAYJADE } from './publicBrands';

/** Used when GET /brand/get is unavailable (local API without brand module). */
export const STATIC_PUBLIC_BRANDS = [
  {
    id: null,
    name: 'StayJade',
    slug: PUBLIC_BRAND_STAYJADE,
    description: 'Leisure Villas',
    logoWithBg: 'https://www.stayjade.com/assets/logo-CQAXgZpE.png',
    logoTransparent: 'https://www.stayjade.com/assets/logo-CQAXgZpE.png',
  },
  {
    id: null,
    name: 'Red Olive',
    slug: PUBLIC_BRAND_RED_OLIVE,
    description: 'Urban Stays',
    logoWithBg: 'https://www.theredolive.co/images/logo.png',
    logoTransparent: 'https://www.theredolive.co/images/logo.png',
  },
];
